export const identifyVastTagPartner = (vastTag, partnerMappings) => {
	if (typeof vastTag !== 'string' || !vastTag.trim() || !Array.isArray(partnerMappings))
		return null;
	const normalizedVastTag = vastTag.toLowerCase();
	for (const partnerMapping of partnerMappings) {
		const identifier = partnerMapping.identifiers?.find((value) =>
			normalizedVastTag.includes(value.toLowerCase())
		);
		if (identifier) {
			return {
				partner: partnerMapping.partner,
				identifier,
				floorSource: partnerMapping.floorSource || null
			};
		}
	}

	return null;
};
